import { injectable } from '../shared/inversify';

export const LocationService = Symbol.for('LocationService');

/**
 * Represents a location service.
 */
export interface LocationService {
    /**
     * The host of the location.
     */
    readonly host: string;
    /**
     * The pathname of the location.
     */
    readonly pathname: string;
    /**
     * The search string of the location.
     */
    readonly search: string;
}

/**
 * Service for retrieving information about the current location.
 */
@injectable()
export class LocationServiceImpl implements LocationService {

    /**
     * Gets the host of the current location.
     * @returns The host of the current location.
     */
    get host() {
        /* istanbul ignore next */
        return window.location.host;
    }

    /**
     * Gets the pathname of the current location.
     * @returns The pathname of the current location.
     */
    get pathname() {
        /* istanbul ignore next */
        return window.location.pathname;
    }

    /**
     * Gets the search string of the current location.
     * @returns The search string of the current location.
     */
    get search() {
        /* istanbul ignore next */
        return window.location.search;
    }
}
